const homeCleaningDetailedRateCard = {
  key: "home-cleaning",
  title: "Home Cleaning & Maid Detailed Rate Card",
  note:
    "Indicative cleaning and maid support pricing. Final price depends on home size, frequency, task count, chemical use, equipment, and whether the booking is one-time or recurring.",
  sections: [
    {
      title: "One-time Home Cleaning",
      items: [
        { name: "Bathroom cleaning", price: "₹399 onwards per bathroom" },
        { name: "Kitchen deep cleaning", price: "₹699 onwards" },
        { name: "Living / bedroom cleaning", price: "₹499 onwards per room" },
        { name: "Full home cleaning", price: "₹1999 onwards" },
      ],
    },
    {
      title: "Maid Support",
      items: [
        { name: "Dusting + sweeping + mopping", price: "₹1499-₹3999 monthly depending on hours/city" },
        { name: "Utensil cleaning only", price: "₹999-₹2499 monthly" },
        { name: "Maid with cooking assistance", price: "₹2999-₹7999 monthly" },
      ],
    },
    {
      title: "Special Cleaning",
      items: [
        { name: "Sofa cleaning", price: "₹499 onwards" },
        { name: "Mattress cleaning", price: "₹499 onwards" },
        { name: "Car interior basic cleaning", price: "₹399 onwards" },
        { name: "Car full detailing support", price: "₹1499 onwards" },
      ],
    },
  ],
};

export default homeCleaningDetailedRateCard;